import React from 'react';
import styles from '../../styles/Landlord/ApplicationCard.module.css';

const ApplicationCard = ({ application }) => {
  const isGroup = application.type === 'Group';

  // Calculate total income/rent sums for groups
  const calculateGroupIncomeRent = () => {
    const residentIncomeTotal = application.residents.reduce(
      (total, resident) => total + parseFloat(resident.incomeRentRatio),
      0
    ).toFixed(2);
    const cosignerIncome = parseFloat(application.cosigner.incomeRentRatio);
    const totalWithCosigner = (parseFloat(residentIncomeTotal) + cosignerIncome).toFixed(2);

    return { residentIncomeTotal, totalWithCosigner };
  };

  const { residentIncomeTotal, totalWithCosigner } = isGroup
    ? calculateGroupIncomeRent()
    : { residentIncomeTotal: null, totalWithCosigner: null };

  return (
    <div className={`${styles.applicationCard} ${application.isNew ? styles.newApplication : ''}`}>
      <div className={styles.cardHeader}>
        <div className={styles.headerLeft}>
          <h3 className={styles.applicantType}>{application.applicant}</h3>

          {application.isNew && <span className={styles.newBadge}>NEW</span>}
        </div>
        <span className={styles.timeAgo}>{application.timeAgo}</span>
      </div>

      <div className={styles.cardBody}>
        <div className={styles.assessment}>
          MILO Assessment:
          <strong className={`${styles.assessmentBadge} ${styles[application.assessment.toLowerCase()]}`}>
            {application.assessment}
          </strong>
        </div>

        {isGroup ? (
          <>
            <table className={styles.groupTable}>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Credit Score</th>
                  <th>Income/Rent</th>
                  <th>Criminal</th>
                  <th>Adverse</th>
                </tr>
              </thead>
              <tbody>
                {application.residents.map((res, idx) => (
                  <tr key={idx}>
                    <td>{res.name}</td>
                    <td>{res.creditScore}</td>
                    <td>{res.incomeRentRatio}</td>
                    <td>{res.criminal || 'None'}</td>
                    <td>{res.adverse || 'None'}</td>
                  </tr>
                ))}
                <tr className={styles.cosignerRow}>
                  <td>{application.cosigner.name} (Cosigner)</td>
                  <td>{application.cosigner.creditScore}</td>
                  <td>{application.cosigner.incomeRentRatio}</td>
                  <td>N/A</td>
                  <td>N/A</td>
                </tr>
              </tbody>
            </table>
            <div className={styles.groupIncomeSummary}>
              Residents' Total Income/Rent: <strong>{residentIncomeTotal}x</strong>
              <span className={styles.divider}>|</span>
              With Cosigner: <strong>{totalWithCosigner}x</strong>
            </div>
          </>
        ) : (
          <div className={styles.singleApplicantDetails}>
            <div>📊 Credit Score: <strong>{application.creditScore}</strong></div>
            <div>💵 Income/Rent: <strong>{application.incomeRentRatio}</strong></div>
            <div>⚠️ Criminal: <strong>{application.criminal || 'None'}</strong></div>
            <div>🚩 Adverse: <strong>{application.adverse || 'None'}</strong></div>
          </div>
        )}
      </div>

      <div className={styles.cardFooter}>
        <span className={`${styles.statusBadge} ${styles[application.status.toLowerCase().replace(' ', '')]}`}>
          {application.status}
        </span>
        <span className={styles.unitAddress}>{application.unit}</span>
      </div>
    </div>
  );
};

export default ApplicationCard;
